import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _callSuper from "@babel/runtime/helpers/callSuper";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import * as React from 'react';
import { withTheme } from '@emotion/react';
import Downshift from 'downshift';
import { Button } from '../Button';
import { DownshiftField } from '../Field';
import { FlyoverBuilder } from '../Flyover/FlyoverBuilder';
import { formErrorAttribute } from '../Form';
import { withInputContext } from '../Form/withInputContext';
import { CloseIcon, DeleteTagIcon, SearchIcon } from '../icons';
import { LoadingIconPrimary } from '../Loading';
import { fromThemeColors } from '../Theme';
import { withTranslate } from '../util';
import { ResultsList } from './ResultsList';
import { StyledIcon, StyledInputBox, StyledSecondaryIcon, StyledSelectedItem, StyledTypeahead, StyledTypeaheadInput, unselectClass } from './Typeahead.styled';
var _Typeahead = /*#__PURE__*/function (_React$Component) {
  function _Typeahead() {
    var _this;
    _classCallCheck(this, _Typeahead);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, _Typeahead, [].concat(args));
    _defineProperty(_this, "state", {
      isFocused: false,
      isSearching: false,
      input: '',
      results: []
    });
    _defineProperty(_this, "currentTimeout", void 0);
    _defineProperty(_this, "inputRef", /*#__PURE__*/React.createRef());
    _defineProperty(_this, "resultsChildrenRef", /*#__PURE__*/React.createRef());
    _defineProperty(_this, "selectedItemRefs", /*#__PURE__*/React.createRef());
    _defineProperty(_this, "onInputKeyDown", function (e) {
      if (!_this.props.selectedItems || !!_this.state.input) {
        return;
      }
      if (e.key === 'Backspace' || e.key === 'ArrowLeft') {
        _this.focusItemAtIndex(_this.props.selectedItems.length - 1);
      }
    });
    _defineProperty(_this, "onItemKeyDown", function (e, item) {
      if (!_this.props.selectedItems) {
        return;
      }
      var itemIndex = _this.props.selectedItems.indexOf(item);
      if (e.key === 'Backspace' || e.key === 'Delete') {
        var _this$props$onUnselec, _this$props;
        if (itemIndex === 0) {
          _this.focusItemAtIndex(itemIndex + 1);
        } else {
          _this.focusItemAtIndex(itemIndex - 1);
        }
        (_this$props$onUnselec = (_this$props = _this.props).onUnselect) === null || _this$props$onUnselec === void 0 ? void 0 : _this$props$onUnselec.call(_this$props, item);
      }
      if (e.key === 'ArrowLeft') {
        _this.focusItemAtIndex(itemIndex - 1);
      }
      if (e.key === 'ArrowRight') {
        _this.focusItemAtIndex(itemIndex + 1);
      }
    });
    _defineProperty(_this, "onBlur", function (e, closeMenu) {
      var relatedTarget = e.relatedTarget || document.activeElement;
      if (_this.resultsChildrenRef.current && _this.resultsChildrenRef.current.contains(relatedTarget)) {
        return;
      }
      _this.setState({
        isFocused: false
      });
      _this.props.inputContext.makeDirty();
      closeMenu();
      if (_this.props.onBlur) {
        _this.props.onBlur(e);
      }
    });
    _defineProperty(_this, "isInputFocused", function () {
      return _this.state.isFocused;
    });
    _defineProperty(_this, "handleFocus", function () {
      _this.setState({
        isFocused: true
      });
    });
    _defineProperty(_this, "shouldShowError", function (isErrored) {
      if (Boolean(_this.props.onFocusHideError) && _this.isInputFocused()) {
        return false;
      }
      return _this.props.inputContext.isDirty && !_this.state.input && isErrored;
    });
    _defineProperty(_this, "onInputValueChange", function (input) {
      if (_this.props.searchSync) {
        _this.searchSync(input, _this.props.searchSync);
        return;
      }
      if (_this.props.search) {
        _this.searchAsync(input, _this.props.search);
        return;
      }
      console.warn('[citrix-ui] Expected either search or searchSync for Typeahead, but neither prop was supplied');
    });
    _defineProperty(_this, "searchAsync", function (input, searcher) {
      _this.setState(function (state) {
        return {
          input: input || '',
          isSearching: !!input,
          results: !input ? [] : state.results
        };
      });
      if (_this.currentTimeout) {
        clearTimeout(_this.currentTimeout);
      }
      _this.currentTimeout = window.setTimeout(function () {
        if (!_this.props.disabled && input) {
          searcher(input).then(function (results) {
            if (input === _this.state.input) {
              _this.setState({
                results: results || [],
                isSearching: false
              });
            }
          });
        }
      }, 500);
    });
    _defineProperty(_this, "searchSync", function (input, searcher) {
      var results = !_this.props.disabled && input != null ? searcher(input) : [];
      _this.setState({
        input: input || '',
        results: results || []
      });
    });
    _defineProperty(_this, "onSelect", function (item, _ref) {
      var reset = _ref.reset;
      if (_this.props.selectionMode === 'multi') {
        _this.setState({
          input: ''
        });
        reset({
          inputValue: '',
          selectedItem: null
        });
      } else {
        var _input = _this.props.itemToString(item) || '';
        _this.setState({
          input: _input
        });
      }
      _this.props.onSelect(item);
      _this.props.inputContext.makeDirty();
    });
    return _this;
  }
  _inherits(_Typeahead, _React$Component);
  return _createClass(_Typeahead, [{
    key: "render",
    value: function render() {
      var _this$props$selectedI,
        _this$props$selectedI2,
        _this2 = this;
      var t = this.props.t;
      var isAsync = !!this.props.search;
      var showSearchIcon = isAsync || !((_this$props$selectedI = this.props.selectedItems) !== null && _this$props$selectedI !== void 0 && _this$props$selectedI.length);
      var isErrored = !this.props.disabled && Boolean(this.props.required) && !this.props.selectedItem && !((_this$props$selectedI2 = this.props.selectedItems) !== null && _this$props$selectedI2 !== void 0 && _this$props$selectedI2.length);
      var showError = this.shouldShowError(isErrored);
      var textIconColor = fromThemeColors('secondaryText')(this.props);
      return /*#__PURE__*/React.createElement(Downshift, {
        onChange: this.onSelect,
        onInputValueChange: this.onInputValueChange,
        inputValue: this.state.input,
        selectedItem: this.props.selectedItem,
        defaultHighlightedIndex: 0,
        itemToString: this.props.itemToString
      }, function (_ref2) {
        var getRootProps = _ref2.getRootProps,
          getInputProps = _ref2.getInputProps,
          getItemProps = _ref2.getItemProps,
          getMenuProps = _ref2.getMenuProps,
          getLabelProps = _ref2.getLabelProps,
          isOpen = _ref2.isOpen,
          highlightedIndex = _ref2.highlightedIndex,
          clearSelection = _ref2.clearSelection,
          openMenu = _ref2.openMenu,
          closeMenu = _ref2.closeMenu;
        return /*#__PURE__*/React.createElement(DownshiftField, _extends({}, getRootProps({
          refKey: 'innerRef'
        }), {
          getLabelProps: getLabelProps,
          label: _this2.props.label,
          disabled: _this2.props.disabled,
          required: _this2.props.required,
          error: showError && t('citrix-ui:validation.enter_required_value'),
          maxWidth: _this2.props.maxWidth,
          hint: _this2.props.hint
        }), /*#__PURE__*/React.createElement(FlyoverBuilder, {
          sameWidth: true,
          isOpen: isOpen,
          flyover: function flyover() {
            return /*#__PURE__*/React.createElement(ResultsList, {
              getItemProps: getItemProps,
              getMenuProps: getMenuProps,
              input: _this2.state.input,
              highlightedIndex: highlightedIndex,
              results: !_this2.state.input && _this2.props.initialItems ? _this2.props.initialItems : _this2.state.results,
              isSearching: _this2.state.isSearching,
              itemToString: _this2.props.itemToString,
              maxWidth: _this2.props.maxWidth,
              noResultsText: _this2.props.noResultsText
            }, _this2.props.resultsListChildren && /*#__PURE__*/React.createElement("div", {
              ref: _this2.resultsChildrenRef
            }, _this2.props.resultsListChildren({
              closeMenu: function closeMenu() {
                return clearSelection();
              }
            })));
          }
        }, function () {
          var _this2$props$selected, _ref3;
          return /*#__PURE__*/React.createElement(StyledTypeahead, _extends({
            showError: showError
          }, formErrorAttribute(isErrored)), (_this2$props$selected = _this2.props.selectedItems) === null || _this2$props$selected === void 0 ? void 0 : _this2$props$selected.map(function (item) {
            return /*#__PURE__*/React.createElement(StyledSelectedItem, {
              key: _this2.props.itemToString(item),
              tabIndex: 0,
              ref: function ref(node) {
                var map = _this2.getRefMap();
                if (node) {
                  map.set(_this2.props.itemToString(item), node);
                } else {
                  map["delete"](_this2.props.itemToString(item));
                }
              },
              onKeyDown: function onKeyDown(e) {
                return _this2.onItemKeyDown(e, item);
              }
            }, /*#__PURE__*/React.createElement("span", {
              title: _this2.props.itemToString(item)
            }, _this2.props.itemToString(item)), !_this2.props.disabled && /*#__PURE__*/React.createElement("div", {
              className: unselectClass
            }, /*#__PURE__*/React.createElement(Button.IconOnly, {
              icon: DeleteTagIcon,
              size: 16,
              onClick: function onClick() {
                var _this2$props$onUnsele, _this2$props;
                closeMenu();
                (_this2$props$onUnsele = (_this2$props = _this2.props).onUnselect) === null || _this2$props$onUnsele === void 0 ? void 0 : _this2$props$onUnsele.call(_this2$props, item);
              },
              title: t('citrix-ui:typeahead.remove_item')
            })));
          }), (!_this2.props.disabled || _this2.props.selectionMode !== 'multi') && /*#__PURE__*/React.createElement(StyledInputBox, null, /*#__PURE__*/React.createElement(StyledIcon, null, isOpen && _this2.state.isSearching ? /*#__PURE__*/React.createElement(LoadingIconPrimary, {
            size: 16
          }) : showSearchIcon && /*#__PURE__*/React.createElement(SearchIcon, {
            size: 16,
            color: textIconColor
          })), /*#__PURE__*/React.createElement(StyledTypeaheadInput, getInputProps({
            disabled: !!_this2.props.disabled,
            onBlur: function onBlur(e) {
              return _this2.onBlur(e, closeMenu);
            },
            placeholder: _this2.props.disabled ? undefined : (_ref3 = _this2.props.placeholder || t('citrix-ui:typeahead.start_typing')) !== null && _ref3 !== void 0 ? _ref3 : '',
            autoFocus: !!_this2.props.autoFocus,
            hasIcon: showSearchIcon,
            hasSecondaryIcon: true,
            onClick: function onClick() {
              _this2.handleFocus();
              if (_this2.props.searchSync || _this2.props.initialItems || _this2.props.resultsListChildren) {
                openMenu();
              }
              if (_this2.props.searchSync) {
                _this2.searchSync(_this2.state.input, _this2.props.searchSync);
              }
            },
            onKeyDown: _this2.onInputKeyDown,
            ref: _this2.inputRef
          })), !_this2.props.disabled && (_this2.state.input || _this2.props.selectedItem) && /*#__PURE__*/React.createElement(StyledSecondaryIcon, null, /*#__PURE__*/React.createElement(Button.IconOnly, {
            onClick: function onClick() {
              return clearSelection();
            },
            size: 16,
            title: t('citrix-ui:typeahead.clear'),
            icon: CloseIcon
          }))));
        }));
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.currentTimeout) {
        window.clearTimeout(this.currentTimeout);
      }
    }
  }, {
    key: "getRefMap",
    value: function getRefMap() {
      if (!this.selectedItemRefs.current) {
        this.selectedItemRefs.current = new Map();
      }
      return this.selectedItemRefs.current;
    }
  }, {
    key: "focusItemAtIndex",
    value: function focusItemAtIndex(index) {
      var _this$selectedItemRef, _this$selectedItemRef2;
      if (!this.props.selectedItems) {
        return;
      }
      if (index === this.props.selectedItems.length) {
        var _this$inputRef$curren;
        (_this$inputRef$curren = this.inputRef.current) === null || _this$inputRef$curren === void 0 ? void 0 : _this$inputRef$curren.focus();
        return;
      }
      (_this$selectedItemRef = this.selectedItemRefs.current) === null || _this$selectedItemRef === void 0 ? void 0 : (_this$selectedItemRef2 = _this$selectedItemRef.get(this.props.itemToString(this.props.selectedItems[index]))) === null || _this$selectedItemRef2 === void 0 ? void 0 : _this$selectedItemRef2.focus();
    }
  }]);
}(React.Component);
var TypeaheadWithContext = withTheme(withInputContext(withTranslate(_Typeahead)));
export function Typeahead(props) {
  return /*#__PURE__*/React.createElement(TypeaheadWithContext, props);
}